import Vue from "vue";

// eslint-disable-next-line
export function longDate(dateStr) {
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(new Date(dateStr));
}

export function dateFormat(dateStr) {
  // Uma string "YYYY-MM-DD" (sem hora) é sempre interpretada pelo JS como meia-noite UTC —
  // sem forçar timeZone: "UTC" aqui também, ela é lida de volta em hora local e o dia
  // "volta" uma casa em fusos atrás de UTC (ex.: America/Sao_Paulo). Strings com hora (ex.:
  // "2026-09-16 20:28:45") já são interpretadas em hora local pelo JS, então essas devem
  // continuar formatadas em hora local, sem essa opção.
  const somenteData = typeof dateStr === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
  return new Intl.DateTimeFormat("pt-BR", somenteData ? { timeZone: "UTC" } : {}).format(
    new Date(dateStr)
  );
}

export function dateFormatParam(dateStr, format) {
  switch (format) {
    case "y-m-d":
      return dateStr.split("/").reverse().join("-");
    case "d/m/y":
      return dateStr.split("-").reverse().join("/");
    default:
      return dateStr.split("-").reverse().join("/");
  }
}

export function dateFormatHour(dateStr) {
  const timeOptions = {
    hourCycle: "h23",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return new Intl.DateTimeFormat("pt-BR", {
    timeZone: "America/Fortaleza",
    ...timeOptions,
  }).format(new Date(dateStr));
}

export function formatHour(hourStr) {
  // '00:00:00' => '00:00'
  if (hourStr === null) return "- - -";
  const hourSplit = hourStr.split(":");
  const hours = hourSplit[0];
  const minutes = hourSplit[1];
  return `${hours}:${minutes}`;
}

Vue.filter("longDate", longDate);
Vue.filter("dateFormat", dateFormat);
Vue.filter("dateFormatParam", dateFormatParam);
Vue.filter("hour", formatHour);
Vue.filter("dateFormatHour", dateFormatHour);
